export const ROCKET_DATA_CODE = 'ROCKETDATA';
export const BIDEASE_CODE = 'BIDEASE';
export const ROCKET10 = 'ROCKET10';
